// Recém Mamã — correção QA V10.1
// A barra fixa deve utilizar sempre o mesmo ID de variante que o formulário principal.
// Mantém os componentes originais do Suruchi e as validações de disponibilidade.
class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onStickyVariantChange);
  }

  onStickyVariantChange() {
    const select = this.querySelector("select");
    if (!select) return;
    const variantId = select.value;
    const stickyForm = document.getElementById(`product-sticky-form-${this.dataset.section}`);
    const stickyInput = stickyForm?.querySelector('input[name="id"]');
    if (stickyInput) stickyInput.value = variantId;

    // Se o cliente usar o seletor da barra, atualizar também os botões de
    // tamanho do formulário principal, incluindo o preço e a disponibilidade.
    const picker = document.querySelector(
      `variant-radios[data-section="${this.dataset.section}"], variant-selects[data-section="${this.dataset.section}"]`
    );
    if (!picker) return;
    const variants = picker.getVariantData?.() || [];
    const variant = variants.find(v => String(v.id) === String(variantId));
    if (!variant || !variant.available) return;

    const fieldsets = [...picker.querySelectorAll("fieldset")];
    if (fieldsets.length) {
      variant.options.forEach((value, index) => {
        const input = [...(fieldsets[index]?.querySelectorAll('input[type="radio"]') || [])]
          .find(el => el.value === value && !el.disabled);
        if (input) input.checked = true;
      });
    } else {
      const selects = [...picker.querySelectorAll("select")];
      variant.options.forEach((value, index) => {
        if (selects[index]) selects[index].value = value;
      });
    }
    // Invoca o ciclo nativo do tema para sincronizar formulário, preço e stock.
    picker.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
customElements.define("sticky-variant-select", StickyProVariantSelect);

function rmSyncStickyVariant() {
  const stickyPicker = document.querySelector("sticky-variant-select");
  const select = stickyPicker?.querySelector("select");
  if (!select) return;
  const sectionId = stickyPicker.dataset.section;
  const mainForm = document.getElementById(`product-form-${sectionId}`);
  const mainInput = mainForm?.querySelector('input[name="id"]');
  const stickyForm = document.getElementById(`product-sticky-form-${sectionId}`);
  const stickyInput = stickyForm?.querySelector('input[name="id"]');
  const stickyButton = stickyForm?.querySelector('button[name="add"]');
  const mainPicker = document.querySelector(
    `variant-radios[data-section="${sectionId}"], variant-selects[data-section="${sectionId}"]`
  );
  if (!mainInput || !stickyInput) return;

  const selectedId = String(mainInput.value);
  const option = [...select.options].find(el => String(el.value) === selectedId);
  const variant = (mainPicker?.getVariantData?.() || [])
    .find(el => String(el.id) === selectedId);
  if (option) select.value = selectedId;
  stickyInput.value = selectedId;
  if (stickyButton) {
    const available = Boolean(option && !option.disabled && (!variant || variant.available));
    stickyButton.disabled = !available;
    stickyButton.textContent = available
      ? (window.variantStrings?.addToCart || "Adicionar ao carrinho")
      : (window.variantStrings?.soldOut || "Esgotado");
  }
}

// O JS original da Shopify altera o ID escondido e emite "change".
// Escutar essa alteração preserva o tamanho selecionado ao descer a página.
document.addEventListener("change", (event) => {
  if (event.target.matches?.('.product_buy_button_form input[name="id"]')) {
    rmSyncStickyVariant();
  }
});

// Uma combinação de opções inválida não deve permitir comprar a variante antiga.
document.addEventListener("change", (event) => {
  const picker = event.target.closest?.("variant-radios, variant-selects");
  if (!picker) return;
  const stickyButton = document.querySelector('.product__sticky button[name="add"]');
  if (picker.currentVariant === undefined || picker.currentVariant === null) {
    if (stickyButton) stickyButton.disabled = true;
  } else {
    rmSyncStickyVariant();
  }
});

rmSyncStickyVariant();

const BuyButtonForm = document.querySelector(".product_buy_button_form");
const productStickyWrapper = document.querySelector(".product__sticky");
if (BuyButtonForm && productStickyWrapper) {
  window.addEventListener("scroll", function () {
    const BuyButtonOffset = TopOffset(BuyButtonForm);
    const BuyButtonTopOffset = BuyButtonOffset.top;
    if (window.scrollY > BuyButtonTopOffset) {
      productStickyWrapper.classList.add("sticky");
      document.body.classList.add("sticky__cart");
    } else {
      productStickyWrapper.classList.remove("sticky");
      document.body.classList.remove("sticky__cart");
    }
  });
}
